import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./translations";

const savedLang = localStorage.getItem("i18nextLng") || "zh-CN";

i18n.use(initReactI18next).init({
  resources,
  lng: savedLang,
  supportedLngs: ["en", "zh-CN", "zh-TW"],
  load: "currentOnly",
  nonExplicitSupportedLngs: false,
  cleanCode: true,
  lowerCaseLng: false,
  fallbackLng: {
    "zh-TW": ["zh-TW"],
    "zh-HK": ["zh-TW"],
    "zh-Hant": ["zh-TW"],
    zh: ["zh-CN"],
    default: ["en"],
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
